const routers = [
  {
    path: '/ota/romManage',
    name: 'romManage',
    component: resolve => require(['../views/ota/RomManage'], resolve)
  },
  {
    path: '/ota/upgradePlan',
    name: 'upgradePlan',
    component: resolve => require(['../views/ota/UpgradePlan'], resolve)
  }
]
export default routers



// WEBPACK FOOTER //
// ./src/routers/ota.js